<template>
  <lf-modal
    :title="
      $t('ORGANIZATION.COMMUNICATION_TEMPLATES.SEND_EMAIL', {
        address: $t('COMMON.TO').toLowerCase(),
      })
    "
    :close="() => emit('close')"
  >
    <template #content>
      <div class="space-y-6 p-6">
        <select-contacts
          v-if="testData?.contacts"
          v-model="selectedData.recipient_user_ids"
          :contacts="testData.contacts"
          type="email"
        />
        <select-email-branding
          v-model="selectedData.email_customization_id"
          :brandings="testData?.email_customizations"
        />
      </div>
      <modal-buttons
        class="justify-end border-t border-gray-200 bg-white py-5"
        :on-cancel="() => emit('close')"
        :on-save="() => emit('email:send', selectedData)"
        :save-button-text="$t('COMMON.SEND')"
        :disabled="!selectedData.recipient_user_ids.length"
      />
    </template>
  </lf-modal>
</template>
<script setup lang="ts">
import { type PropType, ref } from "vue";

import LfModal from "@/components/ui/Modal.vue";
import ModalButtons from "@/components/ui/ModalButtons.vue";
import SelectContacts from "@/views/deals/components/emails/SelectContacts.vue";
import SelectEmailBranding from "@/views/deals/components/emails/SelectEmailBranding.vue";

import type { SendEmailModalData, TestEmailData } from "@/models/emails";

defineProps({
  testData: {
    type: Object as PropType<TestEmailData | null>,
    required: true,
  },
});

const emit = defineEmits<{
  close: [];
  "email:send": [SendEmailModalData];
}>();

const selectedData = ref<SendEmailModalData>({
  recipient_user_ids: [],
  email_customization_id: null,
});
</script>
